/**
* Dashboard api for the home page
*/

import Dashboard from './dashboard'

export default class DevicesAPI extends Dashboard {
  constructor() {
    super()
  }
  
  getDevices(payload) {
    let accessToken = localStorage.getItem('accessToken')
    let accessUser = localStorage.getItem('accessUser')
    return this.api.get('/admin/devices?user='+ accessUser + '&accessToken=' + accessToken, {
      params: payload
    }).then(response => {
      return response.data
    })
  }
  
  postDevices(context, payload) { 
    console.log('Starting services/dashboardAPIs/devicesAPI.js postDevices context',context)
    console.log('Starting services/dashboardAPIs/devicesAPI.js postDevices payload',payload)
    let accessToken = localStorage.getItem('accessToken')
    let accessUser = localStorage.getItem('accessUser')
    return this.api.post('/admin/devices?user='+ accessUser + '&accessToken=' + accessToken, context
    ).then(response => {
      console.log('RESPONSE: ',response)
      return response.data
    })
  }
  
}